module.exports = __webpack_public_path__ + "img/qr-code-trill.0a50c31.png";